import { render, staticRenderFns } from "./promo_menu.vue.js?vue&type=template&id=7ee639bb!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=template&id=7ee639bb"
import script from "./promo_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=script&lang=js"
export * from "./promo_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports